import React from 'react';
import { TrendingUp, DollarSign, Rocket, Package } from 'lucide-react';
export function CaseStudies() {
  const caseStudies = [{
    icon: TrendingUp,
    metric: '$2M+',
    title: 'The Growth Engine',
    description: 'Produced the investor materials and financial packages required to raise over $2M in equity for a high-growth sports organization.',
    tag: 'Capital Raise'
  }, {
    icon: DollarSign,
    metric: '$7.5M',
    title: 'The Acquisition',
    description: 'Built the LBO and flow-of-funds models used to secure $7.5M in debt financing for a complex PE-backed acquisition.',
    tag: 'M&A Advisory'
  }, {
    icon: Rocket,
    metric: '6-Figures',
    title: 'The "Found Money" Audit',
    description: 'Identified over $100k in annual "lost" capital through a comprehensive audit of vendor contracts, subscription hygiene, and spend governance',
    tag: 'Profit Optimization'
  }, {
    icon: Package,
    metric: '$20M+',
    title: 'Asset Optimization',
    description: 'Created inventory analytics for a $20M+ asset base, improving sell-through via merchandising intelligence.',
    tag: 'Operations'
  }];
  return <section id="case-studies" className="w-full py-24 sm:py-32 px-6 sm:px-8 bg-navy-900" data-id="element-113">
      <div className="max-w-7xl mx-auto" data-id="element-114">
        <div className="text-center mb-16" data-id="element-115">
          <p className="text-gold-500 text-sm font-semibold tracking-[0.2em] uppercase mb-4" data-id="element-116">
            Proven Outcomes
          </p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif text-white mb-6" data-id="element-117">
            Results That Speak for Themselves
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto" data-id="element-118">
            Real engagements. Measurable impact. Here's what institutional-grade
            finance looks like in action.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-119">
          {caseStudies.map((study, index) => {
          const Icon = study.icon;
          return <div key={index} className="group bg-navy-800/50 backdrop-blur-sm rounded-lg p-8 border border-slate-700/50 hover:border-gold-500/30 transition-all duration-300" data-id="element-120">
                <div className="flex items-start justify-between mb-6" data-id="element-121">
                  <div className="w-12 h-12 rounded bg-gold-500/10 flex items-center justify-center" data-id="element-122">
                    <Icon size={24} className="text-gold-500" data-id="element-123" />
                  </div>
                  <span className="text-xs font-semibold tracking-wider uppercase text-slate-500 bg-slate-800 px-3 py-1 rounded-full" data-id="element-124">
                    {study.tag}
                  </span>
                </div>

                <div className="text-4xl sm:text-5xl font-serif text-gold-500 mb-4" data-id="element-125">
                  {study.metric}
                </div>

                <h3 className="text-xl font-serif font-semibold text-white mb-3" data-id="element-126">
                  {study.title}
                </h3>

                <p className="text-slate-400 text-[15px] leading-relaxed" data-id="element-127">
                  {study.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}